import React, {useEffect, useState} from 'react';
import {DataStore} from "@aws-amplify/datastore";
import SettingThingsUp from "../ui/SettingThingsUp";
import {
    UserApplicant,
    UserApplicantAsset,
    UserApplicantDebt,
    UserApplicantEmployment,
    UserApplicantFinancial,
    UserApplicantIncome,
    UserApplicantPersonal,
    UserApplicantProperty,
    UserApplicantTax,
    UserMortgage, UserMortgageExisting, UserMortgageNeeds,
    UserMortgageProgress,
    UserMortgageProperty, UserMortgageRequirement, UserMortgageUploads
} from "../../models";
import {Navigate} from "react-router-dom";
import {Auth} from "aws-amplify";

export const MortgageContext = React.createContext({})

function MortgageProvider(props) {
    //redirect set to true will navigate to start
    const [redirect, setRedirectToStart] = useState(false)
    // legacy
    const createUpdatedMortgageCopy = function (section, updatedInstance, modelName) {
        //console.log('updating mortgage copy')
        //console.log(section, updatedInstance, modelName)
        return UserMortgage.copyOf(section.props.mortgage, newMortgage => {
            if (modelName === 'uploads') {
                //console.log('# change in uploads')
                if (Array.isArray(updatedInstance)) {
                    // adding new models
                    newMortgage.uploads = [...mortgage.uploads, ...updatedInstance]
                } else if (!updatedInstance) {
                    newMortgage.uploads = mortgage.uploads.filter(upload => {
                        return upload.id !== section.toDelete
                    })
                } else {
                    // updating existing model
                    newMortgage.uploads = mortgage.uploads.map(upload => {
                        if (upload.id === updatedInstance.id) {
                            return updatedInstance
                        }
                        return upload
                    })
                }
            } else if (section.applicant) {
                //console.log('# change in applicant')
                const appIndex = 'applicant' + section.applicant
                if (section?.defaultLabel) {

                    if (section?.index) {
                        // updating repeater
                        if (updatedInstance) {
                            // updating existing repeater
                            newMortgage[appIndex][modelName] = mortgage[appIndex][modelName].map(model => {
                                if (model.id === updatedInstance.id) {
                                    return updatedInstance
                                }
                                return model
                            })
                        } else {
                            // deleting existing repeater
                            newMortgage[appIndex][modelName] = mortgage[appIndex][modelName].filter(model => {
                                return model.id !== section.index
                            })
                        }
                    } else {
                        // adding new repeater
                        //console.log(updatedInstance , ' being added')
                        newMortgage[appIndex][modelName] = [...mortgage[appIndex][modelName], updatedInstance]
                    }
                } else if (modelName === 'applicant') {
                    // updating applicant model
                    newMortgage[appIndex] = updatedInstance
                } else {
                    //update applicant * model
                    //console.log('setting new ' + modelName + ' in ' + appIndex)
                    newMortgage[appIndex][modelName] = updatedInstance
                }
            } else if (modelName === 'mortgage') {
                //console.log('# change in mortgage')
                newMortgage.twoApplicants = updatedInstance.twoApplicants
                newMortgage.applicationStage = updatedInstance.applicationStage
                // if received anything other than refiance or purchase for mortgageType .. set the intended use
                if (['FIRSTTIME', 'MOVING', 'BUYTOLET', 'HOLIDAYHOME'].includes(updatedInstance.mortgageType)) {
                    const newProperty = UserMortgageProperty.copyOf(mortgage.property, item => {
                        item.intendedUse = updatedInstance.mortgageType
                    })
                    newMortgage.mortgageType = 'PURCHASE'
                    newMortgage.property = newProperty
                } else {
                    newMortgage.mortgageType = updatedInstance.mortgageType
                }
            } else {
                //console.log('# change in mortgage')
                newMortgage[modelName] = updatedInstance
            }
        })
    }
    const updateMortgage = async function (section, updatedInstance, modelName) {

       // let copy = createUpdatedMortgageCopy(section, updatedInstance, modelName)

       // setMortgage(copy)
    }
    const [mortgage, setMortgage] = useState(false)
    const [applicant1, setApplicant1] = useState(false)
    const [applicant1Personal, setApplicant1Personal] = useState(false)
    const [applicant1Employment, setApplicant1Employment] = useState(false)
    const [applicant1Income, setApplicant1Income] = useState(false)
    const [applicant1Financial, setApplicant1Financial] = useState(false)
    const [applicant1Tax, setApplicant1Tax] = useState(false)
    const [applicant1Properties, setApplicant1Properties] = useState(false)
    const [applicant1Assets, setApplicant1Assets] = useState(false)
    const [applicant1Debts, setApplicant1Debts] = useState(false)
    const [applicant2, setApplicant2] = useState(false)
    const [applicant2Personal, setApplicant2Personal] = useState(false)
    const [applicant2Employment, setApplicant2Employment] = useState(false)
    const [applicant2Income, setApplicant2Income] = useState(false)
    const [applicant2Financial, setApplicant2Financial] = useState(false)
    const [applicant2Tax, setApplicant2Tax] = useState(false)
    const [applicant2Properties, setApplicant2Properties] = useState(false)
    const [applicant2Assets, setApplicant2Assets] = useState(false)
    const [applicant2Debts, setApplicant2Debts] = useState(false)
    const [mortgageUploads, setMortgageUploads] = useState(false)
    const [mortgageExisting, setMortgageExisting] = useState(false)
    const [mortgageNeeds, setMortgageNeeds] = useState(false)
    const [mortgageProperty, setMortgageProperty] = useState(false)
    const [mortgageRequirement, setMortgageRequirement] = useState(false)
    const [mortgageProgress, setMortgageProgress] = useState(false)
    const [mortgageLoaded,setMortgageLoaded] = useState(false)
    const [applicant1Loaded,setApplicant1Loaded] = useState(false)
    const [applicant2Loaded,setApplicant2Loaded] = useState(false)
    const observeQuery = (config) => {
        switch(config.name){
            case 'setMortgage':
                break
            default:
                if (!mortgageLoaded) return
        }
        let criteria = config?.criteria ? config.criteria : null
        let obs = DataStore.observeQuery(config.model, criteria).subscribe(({items,isSynced}) => {
            if (isSynced){
                //console.log(config.name + ' called after db update ' + items.length)
                config.set(config?.array ? items : items[0])
                switch(config.name){
                    case 'setMortgage': setMortgageLoaded(true)
                        break
                    case 'setApplicant1': setApplicant1Loaded(true)
                        break
                    case 'setApplicant2': setApplicant2Loaded(true)
                }
            }
            else{
                console.log('not synced')
            }

        });
        return () => {
            obs.unsubscribe();
        };
    }
    // Mortgage
    useEffect(() => {
        return observeQuery({
            model: UserMortgage,
            criteria: (c) => c.username('eq', props.user.attributes.sub),
            set: setMortgage,
            name: 'setMortgage'
        })
    }, [])
    useEffect(() => {
        if(mortgageLoaded){
            return observeQuery({
                model: UserMortgageProperty,
                criteria: (c) => c.id('eq', mortgage.userMortgagePropertyId),
                set: setMortgageProperty,
                name: 'setMortgageProperty'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserMortgageNeeds,
                criteria: (c) => c.id('eq', mortgage.userMortgageNeedsId),
                set: setMortgageNeeds,
                name: 'setMortgageNeeds'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserMortgageExisting,
                criteria: (c) => c.id('eq', mortgage.userMortgageExistingId),
                set: setMortgageExisting,
                name: 'setMortgageExisting'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserMortgageRequirement,
                criteria: (c) => c.id('eq', mortgage.userMortgageRequirementId),
                set: setMortgageRequirement,
                name: 'setMortgageRequirement'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserMortgageProgress,
                criteria: (c) => c.mortgageID('eq', mortgage.id),
                set: setMortgageProgress,
                array: true,
                name: 'setMortgageProgress'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserMortgageUploads,
                criteria: (c) => c.observeMID("eq", mortgage.id),
                set: (items) => {
                    // const uploading = items.find(item => item.status === 'UPLOADING')
                    // if (!uploading) {
                        setMortgageUploads(items)
                    // }
                },
                array: true,
                name: 'setMortgageUploads'
            })
        }
    }, [mortgageLoaded])

    //Applicant 1
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserApplicant,
                criteria: (c) => c.id('eq', mortgage.applicant1ID),
                set: setApplicant1,
                name: 'setApplicant1'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantPersonal,
                criteria: (c) => c.id('eq', applicant1.userApplicantPersonalId),
                set: setApplicant1Personal,
                name: 'setApplicant1Personal'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantEmployment,
                criteria: (c) => c.id('eq', applicant1.userApplicantEmploymentId),
                set: setApplicant1Employment,
                name: 'setApplicant1Employment'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantIncome,
                criteria: (c) => c.id('eq', applicant1.userApplicantIncomeId),
                set: setApplicant1Income,
                name: 'setApplicant1Income'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantFinancial,
                criteria: (c) => c.id('eq', applicant1.userApplicantFinancialId),
                set: setApplicant1Financial,
                name: 'setApplicant1Financial'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantTax,
                criteria: (c) => c.id('eq', applicant1.userApplicantTaxId),
                set: setApplicant1Tax,
                name: 'setApplicant1Tax'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantProperty,
                set: (items) => {
                    setApplicant1Properties(items.filter(item => {
                        let id = item?.applicantID ? item.applicantID : item.applicant.id
                        return id === mortgage.applicant1ID
                    }))
                },
                array: true,
                name: 'setApplicant1Properties'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantAsset,
                set: (items) => {
                    setApplicant1Assets(items.filter(item => {
                        let id = item?.applicantID ? item.applicantID : item.applicant.id
                        return id === mortgage.applicant1ID
                    }))
                },
                array: true,
                name: 'setApplicant1Assets'
            })
        }
    }, [applicant1Loaded])
    useEffect(() => {
        if(applicant1Loaded) {
            return observeQuery({
                model: UserApplicantDebt,
                set: (items) => {
                    setApplicant1Debts(items.filter(item => {
                        let id = item?.applicantID ? item.applicantID : item.applicant.id
                        return id === mortgage.applicant1ID
                    }))
                },
                array: true,
                name: 'setApplicant1Debts'
            })
        }
    }, [applicant1Loaded])


    //Applicant 2
    useEffect(() => {
        if(mortgageLoaded) {
            return observeQuery({
                model: UserApplicant,
                criteria: (c) => c.id('eq', mortgage.applicant2ID),
                set: setApplicant2,
                name: 'setApplicant2'
            })
        }
    }, [mortgageLoaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantPersonal,
                criteria: (c) => c.id('eq', applicant2.userApplicantPersonalId),
                set: setApplicant2Personal,
                name: 'setApplicant2Personal'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantEmployment,
                criteria: (c) => c.id('eq', applicant2.userApplicantEmploymentId),
                set: setApplicant2Employment,
                name: 'setApplicant2Employment'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantIncome,
                criteria: (c) => c.id('eq', applicant2.userApplicantIncomeId),
                set: setApplicant2Income,
                name: 'setApplicant2Income'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantFinancial,
                criteria: (c) => c.id('eq', applicant2.userApplicantFinancialId),
                set: setApplicant2Financial,
                name: 'setApplicant2Financial'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantTax,
                criteria: (c) => c.id('eq', applicant2.userApplicantTaxId),
                set: setApplicant2Tax,
                name: 'setApplicant2Tax'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantProperty,
                set: (items) => {
                    setApplicant2Properties(items.filter(item => {
                        let id = item?.applicantID ? item.applicantID : item.applicant.id
                        return id === mortgage.applicant2ID
                    }))
                },
                array: true,
                name: 'setApplicant2Properties'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantAsset,
                set: (items) => {
                    setApplicant2Assets(items.filter(item => {
                        let id = item?.applicantID ? item.applicantID : item.applicant.id
                        return id === mortgage.applicant2ID
                    }))
                },
                array: true,
                name: 'setApplicant2Assets'
            })
        }
    }, [applicant2Loaded])
    useEffect(() => {
        if(applicant2Loaded) {
            return observeQuery({
                model: UserApplicantDebt,
                set: (items) => {
                    setApplicant2Debts(items.filter(item => {
                        let id = item?.applicantID ? item.applicantID : item.applicant.id
                        return id === mortgage.applicant2ID
                    }))
                },
                array: true,
                name: 'setApplicant2Debts'
            })
        }
    }, [applicant2Loaded])
    let ready = props.user && mortgage && applicant1 && applicant1Personal && applicant1Employment && applicant1Income && applicant1Financial && applicant1Tax && applicant1Properties && applicant1Assets && applicant1Debts && applicant2 && applicant2Personal && applicant2Employment && applicant2Income && applicant2Financial && applicant2Tax && applicant2Properties && applicant2Assets && applicant2Debts && mortgageUploads && mortgageProgress
   // console.log(props.user , mortgage , applicant1 , applicant1Personal , applicant1Employment , applicant1Income , applicant1Financial , applicant1Tax , applicant1Properties , applicant1Assets , applicant1Debts , applicant2 , applicant2Personal , applicant2Employment , applicant2Income , applicant2Financial , applicant2Tax , applicant2Properties , applicant2Assets , applicant2Debts , mortgageUploads , mortgageProgress)
    if (mortgage && !mortgage.identityId) {
        const f = async ()=>{
            const credentials = await Auth.currentUserCredentials();
            DataStore.save(UserMortgage.copyOf(mortgage, item => {
                item.identityId = credentials.identityId
            }))
        }
        f()
    }
    return (
        <>
            {redirect && <Navigate to={'/start'}/>}

            {!redirect && !ready && <SettingThingsUp/>}

            {!redirect && ready && (<MortgageContext.Provider value={{
                mortgage: {
                    ...mortgage,
                    applicant1: {
                        ...applicant1,
                        personal: applicant1Personal,
                        employment: applicant1Employment,
                        income: applicant1Income,
                        financial: applicant1Financial,
                        tax: applicant1Tax,
                        properties: applicant1Properties,
                        assets: applicant1Assets,
                        debts: applicant1Debts
                    },
                    applicant2: {
                        ...applicant2,
                        personal: applicant2Personal,
                        employment: applicant2Employment,
                        income: applicant2Income,
                        financial: applicant2Financial,
                        tax: applicant2Tax,
                        properties: applicant2Properties,
                        assets: applicant2Assets,
                        debts: applicant2Debts
                    },
                    progress: mortgageProgress,
                    uploads: mortgageUploads,
                    requirement: mortgageRequirement,
                    needs: mortgageNeeds,
                    property: mortgageProperty,
                    existing: mortgageExisting
                }
            }}>

                {props.children}


            </MortgageContext.Provider>)}
        </>

    );
}

export default MortgageProvider;